import axios from "axios";
import {
    IP
} from "../index";


/**
 * 查询批量生成的卡券
 * @param {*} data
 * @returns
 */
export async function selectApi(data) {
    var resp = await axios.post(`${IP}/admin/cardCoupon/selectCardCoupon`, {
        ...data
    });
    return resp.data;
}


/**
 * 新增优惠券
 * @param {*} data
 * @returns
 */
export async function addApi(data) {
    var resp = await axios.post(`${IP}/admin/cardCoupon/add`, {
        ...data
    });
    return resp.data;
}


/**
 * 修改
 * @param {*} data
 * @returns
 */
export async function updateApi(data) {
    var resp = await axios.post(`${IP}/admin/cardCoupon/update`, {
        ...data
    });
    return resp.data;
}

/*删除 */
export async function deleteApi(data) {
    var resp = await axios.post(`${IP}/admin/cardCoupon/delete`, {
        ...data
    });
    return resp.data;
}


/**
 * 批量新增卡券
 * @param {*} data
 * @returns
 */
export async function addListApi(data) {
    var resp = await axios.post(`${IP}/admin/cardCoupon/addCardCoupon`, {
        ...data
    });
    return resp.data;
}